import { Battery0Bar, Battery3Bar, Battery6Bar, BatteryFull } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import { UnknownBubble } from '../data-icons'

const BatteryIndicatorBubble = ({ value, isOffline }: { value: number; isOffline: boolean }) => {
  const theme = useTheme()

  const offlineText = isOffline ? ' (Offline)' : ''

  const { ariaLabel, iconColor, IconComponent } = {
    0: { ariaLabel: 'Empty battery', iconColor: theme.palette.error.main, IconComponent: Battery0Bar },
    1: { ariaLabel: 'Low battery', iconColor: theme.palette.warning.light, IconComponent: Battery3Bar },
    2: { ariaLabel: 'Medium battery', iconColor: theme.palette.success.light, IconComponent: Battery6Bar },
    3: { ariaLabel: 'Full battery', iconColor: theme.palette.success.light, IconComponent: BatteryFull },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: UnknownBubble }

  return <IconComponent htmlColor={isOffline ? theme.palette.divider : iconColor} aria-label={`${ariaLabel}${offlineText}`} />
}

export default BatteryIndicatorBubble
